import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import "./howItWorksModal.css";

/**
 * Shared "How <feature> Works" modal.
 *
 * rows: [{ icon: <mdi path>, title?: string, body: node }]
 * A row without a title renders body only; body may be any node (text,
 * links, lists).
 */
const HowItWorksModal = ({
  show,
  onHide,
  title,
  rows = [],
  className = "",
  confirmLabel = "Got it",
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    className={`how-it-works-modal ${className}`.trim()}
  >
    <Modal.Body className="pt-0">
      <Modal.Header className="modal-title-with-border" closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-1 px-2">
        <div className="d-flex flex-column gap-4 p-0">
          {rows.map((row, index) => (
            <div
              key={row.title || index}
              className="d-flex align-items-start gap-3"
            >
              {row.icon && (
                <div className="d-flex align-items-center justify-content-center">
                  <Icon
                    path={row.icon}
                    size={1}
                    className="text-primary mt-1"
                  />
                </div>
              )}
              <div className="how-it-works-row">
                {row.title && (
                  <p className="how-it-works-row-title">{row.title}</p>
                )}
                <div className="how-it-works-row-body">{row.body}</div>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal.Body>
  </Modal>
);

export default HowItWorksModal;
